export enum EmailVariables {
  ORIGIN = "{{origin}}",
  DEST = "{{dest}}",
  AVAIL = "{{avail}}",
  TRUCK = "{{truck}}",
  EMAIL = "{{email}}",
  COMPANY = "{{company}}",
  RATE = "{{rate}}",
  REF = "{{ref}}",
  TRIP = "{{trip}}",
  DO = "{{do}}",
  LENGTH = "{{length}}",
  WEIGHT = "{{weight}}",
  TRIP_DO = "{{tripDO}}",
  LOAD = "{{load}}",
  TRUCK_LOCATION = "{{truckLocation}}",
}

export const DynamicEmailVariables = {
  RATE_BY_TRIP_PLUS_PERCENT: /\{\{trip\+([-+]?\d+(?:\.\d+)?)%\}\}/g, // {{trip+10%}}
  RATE_BY_TRIP_PLUS_ABS: /\{\{trip\+([-+]?\d+(?:\.\d+)?)\$\}\}/g, // {{trip+150$}}
  RATE_BY_TRIP_MULTIPLIER: /\{\{trip\*([-+]?\d+(?:\.\d+)?)\}\}/g, // {{trip*1.5}}
  PRICE: /\{\{price=([-+]?\d+(?:\.\d+)?)\}\}/g, // {{price=2000}}
};

export enum BrokerEmailVariables {
  POSTED_LOAD_TRUCK_TYPE = "{{postedLoadTruckType}}",
  POSTED_LOAD_TRUCK_LOAD = "{{postedLoadTruckLoad}}",
  POSTED_LOAD_ORIGIN_DESTINATION = "{{postedLoadOriginDestination}}",
  POSTED_LOAD_ORIGIN = "{{postedLoadOrigin}}",
  POSTED_LOAD_DESTINATION = "{{postedLoadDestination}}",
  POSTED_LOAD_AVAILABILITY_DATE = "{{postedLoadAvailabilityDate}}",
}
